import React from 'react';
import { CheckCircle, Stethoscope } from 'lucide-react';

export default function ProfessionalBadge({ user, size = 'md', showLabel = true }) {
  if (!user?.is_professional) return null;

  const sizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  const professionalTypes = {
    nutricionista: 'Nutricionista',
    medico: 'Médico',
    enfermero: 'Enfermero',
    farmaceutico: 'Farmacéutico',
    otro: 'Profesional de salud'
  };

  return (
    <div className="inline-flex items-center gap-1.5">
      <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full ${
        user.professional_verified 
          ? 'bg-blue-100 text-blue-700' 
          : 'bg-gray-100 text-gray-600'
      }`}>
        <Stethoscope className={sizes[size]} />
        {showLabel && (
          <span className={`font-medium ${textSizes[size]}`}>
            {professionalTypes[user.professional_type] || 'Profesional'}
          </span>
        )}
      </div>
      {user.professional_verified && (
        <CheckCircle className={`${sizes[size]} text-blue-600`} />
      )}
    </div>
  );
}